'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCalendarOutline = function IoIosCalendarOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.3 8.8v5h27.5v-5z m21.2-1.3h7.5v27.5h-30v-27.5h7.5v-2.5h1.3v2.5h12.5v-2.5h1.2v2.5z m6.3 26.3v-18.8h-27.5v18.8h27.5z m0-20v-5h-6.3v2.5h-1.2v-2.5h-12.5v2.5h-1.3v-2.5h-6.2v5h27.5z' })
        )
    );
};

exports.default = IoIosCalendarOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-calendar-outline.js
// module id = 2334
// module chunks = 0